var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73817 8.9036L20.4694 2.07895C21.385 1.72656 22.2734 2.61504 21.921 3.5306L15.0964 21.2618C14.703 22.2838 13.2409 22.2318 12.9482 21.1853L11.0713 14.4748C10.8611 13.7235 10.2765 13.1389 9.52515 12.9287L2.81469 11.0518C1.76823 10.7591 1.71615 9.29697 2.73817 8.9036Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.50668d52bd2c9810c186d19d2bb8baed.svg";
export { ForwardRef as ReactComponent };